import * as React from 'react';

import { cn } from '@/lib/utils';

function Input({ className, type, ...props }: React.ComponentProps<'input'>) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        // Base scaffold classes — every existing `dark:` variant below (Resolution 15) is left
        // untouched; it already works correctly once the `.dark`-class custom variant is in
        // place, needing no per-component edit here.
        'h-9 w-full min-w-0 rounded-md border border-input bg-transparent px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none selection:bg-selected selection:text-selected-foreground file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm dark:bg-input/30',
        // SL-0027, Activity 4, Task 4.3: additional light-mode/base classes over the token layer
        // and the mockup's global `:focus-visible` spec (3px ring, `outline-offset:2px`).
        'border-input bg-card text-foreground min-h-[38px] rounded-md px-3 py-2',
        'focus-visible:border-ring focus-visible:ring-ring focus-visible:ring-[3px] focus-visible:ring-offset-2 focus-visible:outline-none',
        'aria-invalid:border-destructive aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40',
        className,
      )}
      {...props}
    />
  );
}

export { Input };
